import produce from "immer";

import { contextConstants } from "context/constants";

export const initialState = {
  user: null,
  isAdmin: undefined,
  isManager: undefined,
};

export const reducer = produce((draft, action) => {
  const { type, payload } = action;

  switch (type) {
    case contextConstants.auth.USER_UPDATED: {
      draft.user = payload.user;
      break;
    }

    case contextConstants.auth.USER_TYPE_UPDATED: {
      draft.isAdmin = payload.isAdmin;
      draft.isManager = payload.isManager;
      break;
    }

    default:
      break;
  }
});
